import React from 'react';
import { connect } from 'react-redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { BibJacket } from '.';

export class BibJacketContainer extends React.PureComponent {
  render() {
    return <BibJacket {...this.props} />;
  }
}

BibJacketContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  catalogBib: ownProps.catalogBib || selectCatalogBib(state)
});

export default connect(mapStateToProps)(BibJacketContainer);
